import IntlMessage, {
    IntlMessageValue
} from '../../../../@WUM/core/component/const/IntlMessage'
import React from 'react'
import SunEditorBig from '../../../../@WUM/core/component/const/SunEditorBig'
import { SunEditorConfig } from '../../../../@WUM/core/component/const/SunEditorConfig'

function configuration(
    conf: string,
    response: any,
    newElement: any = false,
    Store: any
) {
    let cutDate =
        newElement === false
            ? response.event !== undefined && response.event !== null && response.event.eventdate !== undefined && response.event.eventdate !== null
                ? response.event.eventdate.split(' ')[0]
                : null
            : ' '

    let cutDateend =
        newElement === false
            ? response.event !== undefined && response.event !== null && response.event.eventEnd !== undefined && response.event.eventEnd !== null
                ? response.event.eventEnd.split(' ')[0]
                : null
            : ' '

    const titel = (
        <>
            <h2>
                <IntlMessage
                    messageId="configuration.home.title"
                    Store={Store}
                />
            </h2>
        </>
    )

    const description = (
        <>
            <p>
                <IntlMessage
                    messageId="configuration.home.description"
                    Store={Store}
                />
            </p>
        </>
    )

    const dataColOne = [
        {
            formType: 'input',
            type: 'hidden',
            name: 'event[discr]',
            value: newElement === false && response.event !== undefined && response.event !== null ? response.event.discr : null
        },
        {
            formType: 'input',
            type: 'hidden',
            name: 'event[layout]',
            value: newElement === false && response.event !== undefined && response.event !== null  ? response.event.layout : null
        },
        {
            formType: 'input',
            type: 'hidden',
            name: 'event[id]',
            value: newElement === false && response.event !== undefined && response.event !== null  ? response.event.id : null
        },
        {
            formType: 'input',
            label: <IntlMessage messageId="comment.event.name" Store={Store} />,
            type: 'text',
            placeholder: IntlMessageValue(
                'de',
                'common.provide_pagetitle',
                Store
            ),
            name: 'event[title]',
            value: newElement === false && response.event !== undefined && response.event !== null  ? response.event.title : null
        },
        {
            formType: 'multiply',
            cols: [
                {
                    formType: 'input',
                    label: (
                        <IntlMessage
                            messageId="comment.event.begin"
                            Store={Store}
                        />
                    ),
                    type: 'datetime-local',
                    name: 'event[eventdate]',
                    format: 'en',
                    nowFormat: 'en',
                    placeholder: 'xx.xx.xxxx',
                    value: cutDate
                },
                {
                    formType: 'input',
                    label: (
                        <IntlMessage
                            messageId="comment.event.end"
                            Store={Store}
                        />
                    ),
                    type: 'datetime-local',
                    name: 'event[eventEnd]',
                    format: 'en',
                    nowFormat: 'en',
                    placeholder: 'xx.xx.xxxx',
                    value: cutDateend
                }
            ]
        },
        {
            formType: 'multiply',
            cols: [
                {
                    formType: 'input',
                    label: (
                        <IntlMessage
                            messageId="comment.event.link.title"
                            Store={Store}
                        />
                    ),
                    type: 'text',
                    placeholder: IntlMessageValue(
                        'de',
                        'common.provide_pagetitle',
                        Store
                    ),
                    name: 'event[linkTitle]',
                    value: newElement === false && response.event !== undefined && response.event !== null ? response.event.linkTitle : null
                },
                {
                    formType: 'input',
                    label: (
                        <IntlMessage
                            messageId="comment.event.link.url"
                            Store={Store}
                        />
                    ),
                    type: 'text',
                    placeholder: IntlMessageValue(
                        'de',
                        'common.provide_pagetitle',
                        Store
                    ),
                    name: 'event[linkUrl]',
                    value: newElement === false && response.event !== undefined && response.event !== null ? response.event.linkUrl : null
                }
            ]
        },
        SunEditorBig(
            (response.event !== undefined && response.event !== null ? response.event  : {} ) ,
            'shortDescription',
            newElement,
            { lang: 'de', height: '250px;', config: SunEditorConfig() },
            'event[shortDescription]',
            <IntlMessage messageId="common.short_description" Store={Store} />,
            '',
            '',
            '',
            '',
            'classic',
            '120'
        )
    ]

    const dataColtwo = [
        {
            formType: 'fetchselect',
            local: 'allTaxon',
            valueState: 'id',
            labelState: 'name',
            beginn: 'true',
            start: 0,
            name: 'event[taxon_id]',
            selected: newElement === false && response.event !== undefined && response.event !== null  ? response.event.taxon_id : null,
            label: IntlMessageValue('de', 'category.main', Store)
        },
        {
            formType: 'multiply',
            cols: [
                {
                    formType: 'image',
                    altLink: true,
                    id: 'image_title_image_',
                    path:
                        newElement === false  && response.event !== undefined && response.event !== null
                            ? response.event.image !== null
                                ? response.event.image !== undefined
                                    ? response.event.image.cdn_url
                                    : ''
                                : ''
                            : '',
                    width: '44',
                    height: '44',
                    class: 'elementsIMg',
                    size: {
                        xl: 12,
                        md: 12,
                        sm: 12
                    }
                },
                {
                    formType: 'formFile',
                    onclick: true,
                    onclick_context: 'pielers_element_text_image',
                    append: 'image_id',
                    src: 'image_title_image_',
                    experiment: true,
                    size: {
                        xl: 12,
                        md: 12,
                        sm: 12
                    }
                }
            ]
        },
        {
            formType: 'input',
            name: 'event[mediaId]',
            id: 'image_id',
            visible: true,
            type: 'hidden',
            placeholder: 'imageID',
            value:
                newElement === false  && response.event !== undefined && response.event !== null
                    ? response.event.mediaId !== null
                        ? response.event.mediaId !== undefined
                            ? response.event.mediaId
                            : null
                        : null
                    : null
        },
        {
            formType: 'multiply',
            cols: [
                {
                    formType: 'select',
                    label: (
                        <IntlMessage Store={Store} messageId="common.visible" />
                    ),
                    name: 'event[visible]',
                    selected: newElement === false && response.event !== undefined && response.event !== null  ? response.event.visible : 0,
                    options: [
                        {
                            label: IntlMessageValue(
                                'de',
                                'common.activated',
                                Store
                            ),
                            value: '1'
                        },
                        {
                            label: IntlMessageValue(
                                'de',
                                'common.deactivated',
                                Store
                            ),
                            value: '0'
                        }
                    ]
                },
                {
                    formType: 'select',
                    label: 'Bereich',
                    name: 'event[taxon_id]',
                    selected: newElement === false && response.event !== undefined && response.event !== null  ? response.event.taxon_id : 0,
                    options: [
                        {
                            label: 'Intern',
                            value: '2'
                        },
                        {
                            label: 'Öffentlich',
                            value: '1'
                        }
                    ]
                }
            ]
        }
    ]

    if (conf === 'titel') {
        return titel
    } else if (conf === 'description') {
        return description
    } else if (conf === 'dataColOne') {
        return dataColOne
    } else if (conf === 'dataColtwo') {
        return dataColtwo
    }
}

export default configuration
